import { render, staticRenderFns } from "./pick-list.vue?vue&type=template&id=f820f164&scoped=true"
import script from "./pick-list.vue?vue&type=script&lang=js"
export * from "./pick-list.vue?vue&type=script&lang=js"
import style0 from "./pick-list.vue?vue&type=style&index=0&id=f820f164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f820f164",
  null
  
)

export default component.exports